// 获取当前运营系统的类型
export const getSysType = () => {
  let sys = 'unknown'
  if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    sys = 'ios'
  } else if (
    navigator.userAgent.indexOf('Android') > -1 ||
    navigator.userAgent.indexOf('Adr') > -1
  ) {
    sys = 'android'
  } else if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    sys = 'pc'
  }
  return sys
}

/**
 * 获取当前程序运行的app类型，如转转、找靓机等
 * @returns
 */
export const getAppType = () => {
  let app = 'unknownApp'
  const userAgent = navigator.userAgent
  if (userAgent.indexOf('zhaoliangji-v2') !== -1) {
    app = 'zlj'
  } else if (userAgent.toLowerCase().indexOf('zhuanzhuan') !== -1) {
    app = 'zz'
  }
  return app
}
